import React from 'react';
import ModalCart from '../../ModalCart';

export default function Cart() {
  return <ModalCart open handleClose={() => window.history.back()} />;
}
